import { moment } from '@hotjar/webapp/lib/moment';
import { DATE_FORMAT } from './GlobalFilterQuery/constants';

export const VALUE_DELIMITER = '-';
const ENCODE_ESCAPE_CHAR = '\\';

export function encode(value: string): string {
  return value
    .replaceAll(ENCODE_ESCAPE_CHAR, ENCODE_ESCAPE_CHAR + ENCODE_ESCAPE_CHAR)
    .replaceAll(VALUE_DELIMITER, ENCODE_ESCAPE_CHAR + VALUE_DELIMITER);
}

export function decode(value: string): string {
  return value
    .replaceAll(ENCODE_ESCAPE_CHAR + VALUE_DELIMITER, VALUE_DELIMITER)
    .replaceAll(ENCODE_ESCAPE_CHAR + ENCODE_ESCAPE_CHAR, ENCODE_ESCAPE_CHAR);
}

export function delimit(...rest: string[]): string {
  return rest.map(encode).join(VALUE_DELIMITER);
}

export function delimitWithoutEncode(...rest: string[]): string {
  return rest.join(VALUE_DELIMITER);
}

export function undelimit(value: string): string[] {
  const values: string[] = [];
  let position = 0;
  let isEscaped = false;

  for (let i = 0; i < value.length; i++) {
    const currentChar = value[i];
    if (!isEscaped && currentChar === ENCODE_ESCAPE_CHAR) {
      isEscaped = true;
      continue;
    }

    if (!isEscaped && currentChar === VALUE_DELIMITER) {
      values.push(value.substring(position, i));
      position = i + VALUE_DELIMITER.length;
    }

    isEscaped = false;
  }

  values.push(value.substring(position, value.length));

  return values.map(decode);
}

export function encodeDate(date: Date): string {
  return moment(date).format(DATE_FORMAT);
}

export function decodeDate(value: string): Date | undefined {
  const m = moment(value, DATE_FORMAT, true);
  if (!m.isValid()) return undefined;
  return m.toDate();
}

export function parseNumber(value: string): number | undefined {
  if (value.length === 0) return undefined;
  const num = Number(value);
  if (isNaN(num)) return undefined;
  return num;
}
